import React, { useEffect, useState } from "react";
import {
  alertAdd,
  fetchTerms,
  register_organization,
  join_organization,
  fetchOrgNames,
} from "../../redux/actions";
import { connect, useDispatch, useSelector } from "react-redux";
import Loader from "../../components/loader";
import ReCAPTCHA from "react-google-recaptcha";
import LeftComponentMui from "../../left-component-mui";
import Grid from "@material-ui/core/Grid";
import { Box } from "@material-ui/core";
import { LockOpen, Visibility } from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import styled from "styled-components";
import s from "./index.module.css";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
import { brand } from "../../theme";
import { usePasswordStrength } from "../../hooks/usePasswordStrength";
import { PasswordStrengthMeter } from "../../components/password-strength-meter";

const OrangeButton = styled(Button)`
  background-color: ${brand.teal};
  color: white;
`;

const registerStatusLabels = [
  { value: "join", label: "Dołącz do organizacji" },
  { value: "create", label: "Załóż organizację" },
];

const hasRecaptchaDefined = !!process.env.REACT_APP_RECAPTCHA_SITEKEY;

const RegisterOrganisation = ({
  creatingOrganization,
  joiningComplete,
  joiningOrganization,
  joinedOrganization,
  history,
  fetchOrgNames,
  names,
}) => {
  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [formIsValid, setFormIsValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [recaptchaValid, setRecaptchaValid] = useState(!hasRecaptchaDefined);
  const {
    score: passwordScore,
    requirements: passwordRequirements,
  } = usePasswordStrength(password);
  const [termList, setTermList] = useState([]);
  const [allTermsAccepted, setAllTermsAccepted] = useState(false);

  const [orgNames, setOrgNames] = useState([]);
  const [orgCode, setOrgCode] = useState("");

  const [selectedOrg, setSelectedOrg] = useState("");
  const [isRegisterInProgress, setIsRegisterInProgress] = useState(false);
  const [registerCompleted, setRegisterCompleted] = useState(false);

  const [invalidPasswordInputChar, setInvalidPasswordInputChar] = useState(
    false
  );

  const [registerStatus, setRegisterStatus] = useState("join");

  const dispatch = useDispatch();

  const terms = useSelector((s) => s.terms);
  const globalTheme = useSelector((s) => s.globalTheme);

  useEffect(() => {
    fetchOrgNames();
  }, []);

  useEffect(() => {
    if (names) {
      setOrgNames(
        names.map(({ id: value, orgName: label }) => ({
          value,
          label,
        }))
      );
    }
  }, [names]);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleInstructionClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (termList.length === 0) {
      dispatch(fetchTerms());
    }

    setAllTermsAccepted(
      termList.reduce((all, current) => all && current.accepted, true)
    );
  }, [termList]);

  useEffect(() => {
    if (terms.length > 0) {
      setTermList(
        terms.map((t) => ({
          ...t,
          accepted: false,
        }))
      );
    }
  }, [terms]);

  const handleRegistrationStatus = (event) => {
    if (names) {
      setOrgNames(
        names.map(({ id: value, orgName: label }) => ({
          value,
          label,
        }))
      );
    }

    setRegisterStatus(event.currentTarget.value);
  };

  useEffect(() => {
    if (registerCompleted) {
      dispatch(
        alertAdd({
          text: "Rejestracja przebiegła pomyślnie.",
          isSuccess: true,
        })
      );
      history.push("/login");
    }
  }, [registerCompleted]);

  const submit = async (e) => {
    e.preventDefault();

    if (formIsValid) {
      try {
        if (registerStatus === "create") {
          setIsRegisterInProgress(true);
          const response = await dispatch(
            register_organization({
              name,
              mail,
              password,
            })
          );

          if (response.status === 200) {
            setRegisterCompleted(true);
          } else {
            const message = response.data.message;

            if (message.indexOf("Email is not unique") !== -1) {
              dispatch(
                alertAdd({
                  text: "Email nie jest unikalny.",
                  isError: true,
                })
              );
            } else if (
              message.indexOf("Organization name is not unique") !== -1
            ) {
              dispatch(
                alertAdd({
                  text: "Nazwa organizacji nie jest unikalna",
                  isError: true,
                })
              );
            }
          }
          setIsRegisterInProgress(false);
        } else {
          await dispatch(
            join_organization({
              selectedOrg,
              mail,
              password,
              orgCode,
            })
          );
          dispatch(
            alertAdd({
              text: "Rejestracja przebiegła pomyślnie.",
              isSuccess: true,
            })
          );
          history.push("/login");
        }
      } catch (e) {
        let errorMessage;
        if (e.response.status === 409) {
          if (e.response.data.message === "Invalid organization code") {
            errorMessage = "Błąd rejestracji, nieprawidłowy kod organizacji.";
          } else if (
            e.response.data.message.includes("Invalid email address")
          ) {
            errorMessage = "Błąd rejestracji, niepoprawny format adresu email.";
          } else {
            errorMessage =
              "Błąd rejestracji, email jest już używany w systemie.";
          }
        } else {
          errorMessage = `Błąd rejestracji, (${e.message}).`;
        }

        dispatch(
          alertAdd({
            text: errorMessage,
            isError: true,
          })
        );
      }
    }
  };

  const cancel = (e) => {
    e.preventDefault();

    history.push("/login");
  };

  const testEmailPattern = (mail) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      mail
    );
  };

  useEffect(() => {
    const isCodeRequried =
      names?.find((org) => org.id === selectedOrg)?.enableCodeRegistration ||
      false;
    registerStatus === "create"
      ? setFormIsValid(
          name &&
            testEmailPattern(mail) &&
            password &&
            passwordsMatch &&
            recaptchaValid &&
            allTermsAccepted &&
            passwordScore > 4
        )
      : isCodeRequried
      ? setFormIsValid(
          selectedOrg &&
            testEmailPattern(mail) &&
            password &&
            orgCode &&
            passwordsMatch &&
            recaptchaValid &&
            allTermsAccepted &&
            passwordScore > 4
        )
      : setFormIsValid(
          selectedOrg &&
            testEmailPattern(mail) &&
            password &&
            passwordsMatch &&
            recaptchaValid &&
            allTermsAccepted &&
            passwordScore > 4
        );
  }, [
    name,
    mail,
    passwordsMatch,
    password,
    recaptchaValid,
    allTermsAccepted,
    orgCode,
    passwordScore,
    selectedOrg,
  ]);

  useEffect(() => {
    setPasswordsMatch(password === password2);
  }, [password, password2]);

  const onChange = (value) => {
    setRecaptchaValid(!!value);
  };

  return (
    <Grid
      container
      style={{
        minHeight: "100vh",
        backgroundColor: globalTheme === "high-contrast" ? "black" : undefined,
      }}
    >
      <LeftComponentMui />

      <Grid item sm={12} xs={12} md={4}>
        <Box p={1}>
          <Box textAlign="center">
            <LockOpen />
          </Box>
          {registerStatus === "create" ? (
            <Loader
              loading={creatingOrganization || isRegisterInProgress}
              text="Tworzenie organizacji"
            />
          ) : (
            <Loader
              loading={joiningOrganization || isRegisterInProgress}
              text="Dołączanie do organizacji"
            />
          )}

          {!creatingOrganization &&
            !joiningOrganization &&
            !isRegisterInProgress && (
              <>
                <Box as="h1" fontSize={20} textAlign="center">
                  Zarejestruj się
                </Box>
                {registerStatus === "create" && (
                  <Box mt={1} as="h1" fontSize={15} textAlign="left">
                    Rejestrujesz się jako administrator oraz jednocześnie
                    zakładasz własną{" "}
                    <Tooltip title="W ramach organizacji, możesz budować formularze, zarządzać grupami użytkowników, udostępniając im formularze oraz przeglądać wyniki i eksportować je do własnych systemów.">
                      <a>organizację</a>
                    </Tooltip>
                    .
                  </Box>
                )}
                {registerStatus === "join" && (
                  <Box mt={1} as="h1" fontSize={15} textAlign="left">
                    Rejestrujesz się jako{" "}
                    {process.env.REACT_APP_USE_PATIENT === "true"
                      ? `pacjent`
                      : `użytkownik`}{" "}
                    oraz jednocześnie dołączasz do istniejącej już organizacji.
                  </Box>
                )}
                {/* <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      value={registerStatus || "create"}
                      name="customized-radios"
                    >
                      {registerStatusLabels.map((status, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            value={status.value}
                            label={status.label}
                            control={<Radio color={"primary"} />}
                            onChange={handleRegistrationStatus}
                          />
                        );
                      })}
                    </RadioGroup>
                  </FormControl>
                </Box> */}
                <form onSubmit={submit} noValidate autoComplete="off">
                  {registerStatus === "create" ? (
                    <Box mt={1}>
                      <TextField
                        label="Imię i nazwisko"
                        variant="outlined"
                        value={name}
                        required
                        fullWidth
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Box>
                  ) : (
                    <Box mt={1}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="select-outlined-label">
                          Wybierz organizację
                        </InputLabel>
                        <Select
                          labelId="select-outlined-label"
                          id="select-outlined"
                          value={selectedOrg}
                          fullWidth
                          required
                          onChange={(event) =>
                            setSelectedOrg(event.target.value)
                          }
                          label="Wybierz organizację"
                        >
                          {orgNames.map((org, index) => {
                            return (
                              <MenuItem key={index} value={org.value}>
                                {org.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <Box mt={1}>
                        {names !== undefined &&
                          selectedOrg !== "" &&
                          names.find((tmpOrg) => {
                            return tmpOrg.id === selectedOrg;
                          }).enableCodeRegistration && (
                            <TextField
                              required
                              label={"Kod organizacji"}
                              variant="outlined"
                              value={orgCode}
                              fullWidth
                              onChange={(e) => setOrgCode(e.target.value)}
                            />
                          )}
                      </Box>
                    </Box>
                  )}

                  <Box mt={1}>
                    <TextField
                      error={!(mail === "" || testEmailPattern(mail))}
                      helperText={
                        !(mail === "" || testEmailPattern(mail)) &&
                        "Nieprawidłowy adres email"
                      }
                      label={
                        registerStatus === "create"
                          ? "Email właściciela"
                          : process.env.REACT_APP_USE_PATIENT === "true"
                          ? "Email pacjenta"
                          : "Email użytkownika"
                      }
                      variant="outlined"
                      required
                      value={mail}
                      fullWidth
                      onChange={(e) => setMail(e.target.value)}
                    />
                  </Box>
                  <Box mt={1} display="flex">
                    <TextField
                      label="Hasło"
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      error={invalidPasswordInputChar}
                      helperText={
                        invalidPasswordInputChar
                          ? "Spacja nie jest dozwolona."
                          : ""
                      }
                      required
                      onChange={(e) => {
                        if (e.target.value.includes(" ")) {
                          setInvalidPasswordInputChar(true);
                          setTimeout(
                            () => setInvalidPasswordInputChar(false),
                            3000
                          );
                        } else {
                          setInvalidPasswordInputChar(false);
                        }
                        setPassword(e.target.value.split(" ").join(""));
                      }}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              aria-label="toggle password visibility"
                            >
                              <Visibility />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <TextField
                      error={password2 && !passwordsMatch}
                      helperText={
                        password2 && !passwordsMatch
                          ? "Powtórzone hasło nie jest zgodne"
                          : ""
                      }
                      label="Powtórz hasło"
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      value={password2}
                      required
                      onChange={(e) =>
                        setPassword2(e.target.value.split(" ").join(""))
                      }
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              aria-label="toggle password visibility"
                            >
                              <Visibility />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Box mt={1}>
                    <span className={s.formHint}>* Pola wymagane</span>
                  </Box>
                  <PasswordStrengthMeter
                    score={passwordScore}
                    requirements={passwordRequirements}
                  />

                  <Box mt={1}>
                    {termList && termList.length > 0 && (
                      <label>Akceptuję następujące regulaminy: </label>
                    )}{" "}
                  </Box>

                  <Box>
                    {termList &&
                      termList.length > 0 &&
                      termList.map((term) => {
                        return (
                          <div key={term.id}>
                            <input
                              type="checkbox"
                              checked={term.accepted}
                              onChange={() => {
                                setTermList(
                                  termList.map((acceptedTerm) =>
                                    acceptedTerm.id === term.id
                                      ? {
                                          ...acceptedTerm,
                                          accepted: !acceptedTerm.accepted,
                                        }
                                      : acceptedTerm
                                  )
                                );
                              }}
                              style={{ marginRight: "5px", marginLeft: "10px" }}
                            />
                            <span>
                              <label style={{ marginRight: "8px" }}>
                                {term.name}
                              </label>
                              <a
                                href={`/org-media/files${term.link}`}
                                target={"_blank"}
                              >
                                przeczytaj
                              </a>
                            </span>
                          </div>
                        );
                      })}{" "}
                  </Box>

                  <Box mt={1}>
                    { process.env.REACT_APP_RECAPTCHA_SITEKEY && (
                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
                            onChange={onChange}
                        />
                    )}
                  </Box>
                  <Box mt={1} display="flex">
                    <Button variant={"contained"} fullWidth onClick={cancel}>
                      Anuluj
                    </Button>
                    <OrangeButton
                      type="submit"
                      variant={"contained"}
                      fullWidth
                      disabled={!formIsValid}
                    >
                      Zarejestruj się
                    </OrangeButton>
                  </Box>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        color="primary"
                        variant="contained"
                        onClick={handleInstructionClick}
                    >
                      INSTRUKCJA
                    </Button>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                      <MenuItem
                          onClick={() => {
                            setAnchorEl(null);
                            window.open(
                                "/org-media/files/public/instrukcja_uzytkownika.pdf",
                                "_blank"
                            );
                          }}
                      >
                        Instrukcja dla{" "}
                        {process.env.REACT_APP_USE_PATIENT === "true"
                            ? "pacjenta"
                            : "użytkownika"}{" "}
                        PDF
                      </MenuItem>
                    </Menu>
                  </Box>
                </form>
              </>
            )}
        </Box>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  creatingOrganization: state.creatingOrganization,
  joiningOrganization: state.joiningOrganization,
  joinedOrganization: state.joinedOrganization,
  joiningComplete: state.joiningComplete,
  names: state.orgNames,
});

const mapDispatchToProps = (dispatch) => ({
  fetchOrgNames: () => dispatch(fetchOrgNames()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterOrganisation);
